/**
 * Custom error class for handling client-side errors in the EagleInfo application.
 * Extends the native JavaScript Error class to provide consistent error handling
 * with stack trace support.
 */
export class EagleInfoClientError extends Error {
  /**
   * Creates a new instance of EagleInfoClientError.
   * @param {string} message - The error message that should be shown to the user.
   */
  constructor(message: string) {
    super(message);
    this.name = 'EagleInfoClientError';
    // Capture the current stack trace and store it in the error object
    Error.captureStackTrace(this, this.constructor);
  }
}
